import { axiosInstance } from "../../shared/axios";
import axios from "axios";

export const adminLoginService = async (creds) => {
  try {
    const { data } = await axiosInstance.post(`/admin/login`, creds);
    return data;
  } catch (e) {
    // Return the backend's full error response if available
    const resp = e?.response?.data;
    if (resp) return resp;
    return {
      error: true,
      message: resp?.message || "Something went wrong",
    };
  }
};

// export const adminLoginService = async (creds) => {
//   try {
//     const { data } = await axiosInstance.post(`/admin/login`, creds);
//     return { data };
//   } catch (e) {
//     // If there's a response from the server, return its data
//     if (e.response?.data) {
//       return { error: e.response.data };
//     }
//     // If no response from server, return a generic error
//     return {
//       error: {
//         message: e.message || "Network error. Please try again.",
//       },
//     };
//   }
// };

// export const adminLoginService = async (creds) => {
//   try {
//     const { data } = await axiosInstance.post(`/admin/login`, creds);
//     return { data };
//   } catch (e) {
//     if (e.response?.data) {
//       return { error: e.response.data };
//     }
//     return {
//       error: {
//         message: e.message || "Network error. Please try again.",
//       },
//     };
//   }
// };

console.log("testing domain", window.location.hostname);

export const getBlogs = async (creds) => {
  try {
    const { data } = await axiosInstance.post(`/get-blogs`, creds);
    return data;
  } catch (e) {
    return {
      error: "Something went wrong",
    };
  }
};
export const getBanners = async (creds) => {
  try {
    const { data } = await axiosInstance.get(`/banners`, creds);
    return data;
  } catch (e) {
    return {
      error: "Something went wrong",
    };
  }
};
export const getStore = async () => {
  try {
    const { data } = await axiosInstance.get(`/store`);
    return data;
  } catch (e) {
    return {
      error: "Something went wrong",
    };
  }
};
export const getCities = async () => {
  try {
    const { data } = await axiosInstance.get(`/locator`);
    return data;
  } catch (e) {
    return {
      error: "Something went wrong",
    };
  }
};

export const getSpecificcityDetails = async (id) => {
  try {
    const { data } = await axiosInstance.get(`locator/${id}`);
    return data;
  } catch (e) {
    return {
      error: "something went wrong",
    };
  }
};

export const getOnlyStateCities = async () => {
  try {
    const { data } = await axiosInstance.get(`locator/ordered`);
    return data;
  } catch (e) {
    return {
      error: "Someting went wrong",
    };
  }
};

export const reOrderedCities = async (payload) => {
  try {
    const { data } = await axiosInstance.post(`/locator/reorder`, payload);
    return data;
  } catch (e) {
    return {
      error: "Something wenmt wrong",
    };
  }
};

export const getNewslinks = async (creds) => {
  try {
    const { data } = await axiosInstance.post(`/get-presses`, creds);
    return data;
  } catch (e) {
    return {
      error: "Something went wrong",
    };
  }
};

export const getVehicleOrders = async (params = {}) => {
  try {
    // ✅ Use the correct localStorage key
    const token = localStorage.getItem("obenev-token");

    const {
      page = 1,
      pageSize = 10,
      startDate = null,
      sortBy = null,
      sortOrder = null,
      search = null,
      status = null,
    } = params;

    // Build query params safely — skip empty/null values
    const queryParams = new URLSearchParams();

    queryParams.append("page", String(page));
    queryParams.append("pageSize", String(pageSize));

    if (startDate) queryParams.append("startDate", startDate);
    if (sortBy) queryParams.append("sortBy", sortBy);
    if (sortOrder) queryParams.append("sortOrder", sortOrder);
    if (search && search.trim()) queryParams.append("search", search.trim());
    if (status && status.trim()) queryParams.append("status", status.trim());
    const { data } = await axiosInstance.get(
      `/customer/get-all-vehicle-orders?${queryParams}`,
      {
        headers: {
          Accept: "application/json, text/plain, */*",
          "Accept-Language": "en-US,en;q=0.9,hi;q=0.8",
          Authorization: token ? `Bearer ${token}` : "",
        },
      },
    );

    return data;
  } catch (e) {
    console.error("Error in getVehicleOrders:", e);
    return {
      error: true,
      message: "Something went wrong",
      details: e.message || "Unknown error",
      user: {
        data: [],
        totalCount: 0,
        totalPages: 0,
        currentPage: 1,
        hasPrev: false,
        hasNext: false,
      },
    };
  }
};
export const getblog_Detail = async (creds) => {
  try {
    const { data } = await axiosInstance.post(`/get-blogs-details`, creds);
    return data;
  } catch (e) {
    return {
      error: "Something went wrong",
    };
  }
};

export const getbanner_Detail = async (creds) => {
  console.log("get creds", creds);
  try {
    const { data } = await axiosInstance.get(`/banner/${creds.bannerId}`);
    return data;
  } catch (e) {
    return {
      error: "Something went wrong",
    };
  }
};
export const getPress_detail = async (creds) => {
  try {
    const { data } = await axiosInstance.post(`/get-presses-details`, creds);
    return data;
  } catch (e) {
    return {
      error: "Something went wrong",
    };
  }
};

export const create_Blog = async (creds) => {
  try {
    const { data } = await axiosInstance.post(`/admin/create-blog`, creds);
    return data;
  } catch (e) {
    return {
      error: "Something went wrong",
    };
  }
};
export const create_Banner = async (creds) => {
  try {
    const { data } = await axiosInstance.post(`/admin/banner`, creds);
    return data;
  } catch (e) {
    return {
      error: "Something went wrong",
    };
  }
};
export const create_store = async (payload) => {
  try {
    const { data } = await axiosInstance.post(`/store`, payload);
    return data;
  } catch (e) {
    return {
      error: "Something went wrong",
    };
  }
};
export const create_city = async (payload) => {
  try {
    const { data } = await axiosInstance.post(`/locator`, payload);
    return data;
  } catch (e) {
    // Return the backend's full error response if available
    const resp = e?.response?.data;
    if (resp) return resp;
    return {
      error: true,
      message: resp?.message || "Something went wrong",
    };
  }
};

export const create_Link = async (creds) => {
  try {
    const { data } = await axiosInstance.post(`admin/create-press`, creds);
    return data;
  } catch (e) {
    return {
      error: "Something went wrong",
    };
  }
};

export const delete_blog = async (blogId) => {
  console.log("delete_blog", blogId);
  try {
    const { data } = await axiosInstance.delete(`/admin/delete-blog`, {
      data: { blogId },
    });
    return data;
  } catch (e) {
    return {
      error: "Something went wrong",
    };
  }
};

export const delete_banner = async (creds) => {
  console.log("delete_banner", creds);
  try {
    const { data } = await axiosInstance.delete(
      `/admin/banner/${creds.bannerId}`,
      {
        data: creds,
      },
    );
    return data;
  } catch (e) {
    return {
      error: "Something went wrong",
    };
  }
};
export const delete_city = async (payload) => {
  try {
    const { data } = await axiosInstance.delete(`/locator/${payload._id}`);
    return data;
  } catch (e) {
    return {
      error: "Something went wrong",
    };
  }
};

export const delete_link = async (creds) => {
  try {
    const { data } = await axiosInstance.delete(`/admin/delete-press`, {
      data: creds,
    });
    return data;
  } catch (e) {
    return {
      error: "Something went wrong",
    };
  }
};

export const edit_blog = async (creds) => {
  console.log("creds", creds);

  try {
    const { data } = await axiosInstance.put(`/admin/edit-blog`, creds);
    return data;
  } catch (e) {
    return {
      error: "Something went wrong",
    };
  }
};
export const edit_banner = async (creds) => {
  console.log("creds", creds);

  try {
    const { data } = await axiosInstance.put(
      `/admin/banner/${creds.bannerId}`,
      creds,
    );
    return data;
  } catch (e) {
    return {
      error: "Something went wrong",
    };
  }
};
export const edit_store = async (payload) => {
  try {
    const { data } = await axiosInstance.put(`/store/${payload._id}`, payload);
    return data;
  } catch (e) {
    return {
      error: "Something went wrong",
    };
  }
};
export const edit_city = async (payload) => {
  try {
    const { data } = await axiosInstance.put(
      `/locator/${payload._id}`,
      payload,
    );
    return data;
  } catch (e) {
    // Return the backend's full error response if available
    const resp = e?.response?.data;
    // if (resp) return resp;
    return {
      error: true,
      message: resp?.message || "Something went wrong",
    };
  }
};

export const edit_link = async (creds) => {
  try {
    const { data } = await axiosInstance.put(`/admin/edit-press`, creds);
    return data;
  } catch (e) {
    return {
      error: "Something went wrong",
    };
  }
};

export const getContact_us = async () => {
  try {
    const { data } = await axiosInstance.get(`/get-contactUs`);
    return data;
  } catch (e) {
    return {
      error: "Something went wrong",
    };
  }
};

export const get_Jobs = async () => {
  try {
    const { data } = await axiosInstance.get(`/get-jobs`);
    return data;
  } catch (e) {
    return {
      error: "Something went wrong",
    };
  }
};

export const uploadImage = async (creds) => {
  try {
    const { data } = await axiosInstance.post(`/upload-file`, creds);
    return data;
  } catch (e) {
    return {
      error: "Something went wrong",
    };
  }
};
// export const uploadBannerImage = async (creds) => {
//   try {
//     const { data } = await axiosInstance.post(`/upload-file`, creds);
//     return data;
//   } catch (e) {
//     return {
//       error: "Something went wrong",
//     };
//   }
// };

export const create_Faq_Category = async (creds) => {
  //api.obenev.com/admin/categories
  //api.obenev.com/admin/categories
  // https://api.obenev.com/testimonial

  try {
    const { data } = await axiosInstance.post(`/categories`, creds);
    return data;
  } catch (e) {
    return {
      error: "Something went wrong",
    };
  }
};

//create page catrgory

// export const create_Page_category = async () => {
//   try {
//     const { data } = await axiosInstance.post(`/content-categories`);
//     return data;
//   } catch (e) {
//     return {
//       error: "Something went wrong",
//     };
//   }
// };

export const create_Page_category = async (payload) => {
  try {
    const { data } = await axiosInstance.post(`/metatag-content`, payload);
    return data;
  } catch (e) {
    return {
      error: true,
      message: e.response?.data?.message || "Something went wrong",
    };
  }
};

export const getSingle_Page_category = async (id) => {
  try {
    const { data } = await axiosInstance.get(`/metatag-content/${id}`);
    return data;
  } catch (e) {
    // Return the actual API error message if available
    return {
      error: true,
      message: e.response?.data?.message || "Something went wrong",
    };
  }
};

// export const update_Page_category = async (payload, id) => {
//   const token = localStorage.getItem("obenev-token");
//   try {
//     const { data } = await axiosInstance.put(
//       `/metatag-content/${id}`,
//       payload,
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );
//     return data;
//   } catch (e) {
//     return { error: "Something went wrong" };
//   }
// };

export const update_Page_category = async (payload, id) => {
  try {
    const { data } = await axiosInstance.put(`/metatag-content/${id}`, payload);
    return data; // success response
  } catch (e) {
    // Return the actual API error message if available
    return {
      error: true,
      message: e.response?.data?.message || "Something went wrong",
    };
  }
};

export const create_booking_dynamic_route = async (payload) => {
  try {
    const { data } = await axiosInstance.post(`/dynamic-route`, payload);
    return data;
  } catch (error) {
    return {
      error: true,
      message: error.response?.data?.message || "Something went wrong",
    };
  }
};

export const get_booking_dynamic_route = async () => {
  try {
    const { data } = await axiosInstance.get(`/dynamic-route`);
    return data;
  } catch (error) {
    return {
      error: true,
      message: error.response?.data?.message || "Something went wrong",
    };
  }
};

export const get_single_booking_dynamic_route = async (id) => {
  try {
    const { data } = await axiosInstance.get(`/dynamic-route/${id}`);
    return data;
  } catch (error) {
    return {
      error: true,
      message: error.response?.data?.message || "Something went wrong",
    };
  }
};

export const update_booking_dynamic_route = async (payload, id) => {
  try {
    const { data } = await axiosInstance.put(`/dynamic-route/${id}`, payload);
    return data;
  } catch (error) {
    return {
      error: true,
      message: error.response?.data?.message || "Something went wrong",
    };
  }
};

export const delete_booking_dynamic_route = async (id) => {
  try {
    const { data } = await axiosInstance.delete(`/dynamic-route/${id}`);
    return data;
  } catch (e) {
    return { error: "Something went wrong" };
  }
};

export const delete_Faq_Category = async (id) => {
  try {
    const { data } = await axiosInstance.delete(`/metatag-content/${id}`);
    return data;
  } catch (error) {
    return {
      error: true,
      message: error.response?.data?.message || "Something went wrong",
    };
  }
};

export const update_Faq_Category = async (creds, id) => {
  //api.obenev.com/admin/categories
  //api.obenev.com/admin/categories

  console.log("cr", id);
  try {
    const { data } = await axiosInstance.put(`/categories/${id}`, creds);

    return data;
  } catch (e) {
    return {
      error: "Something went wrong",
    };
  }
};

export const getAll_Faq_Category = async () => {
  try {
    const { data } = await axiosInstance.get(`/categories`);
    return data;
  } catch (e) {
    return {
      error: "Something went wrong",
    };
  }
};

export const getPage_Category = async () => {
  try {
    const { data } = await axiosInstance.get(`/metatag-content-categories`);
    return data;
  } catch (e) {
    return {
      error: "Something went wrong",
    };
  }
};

export const create_Testimonial = async (creds) => {
  try {
    const { data } = await axiosInstance.post(`/testimonial`, creds);
    return data;
  } catch (e) {
    return {
      error: "Something went wrong",
    };
  }
};
export const update_Testimonial = async (creds, id) => {
  try {
    const { data } = await axiosInstance.put(`/testimonial/${id}`, creds);
    return data;
  } catch (e) {
    return {
      error: "Something went wrong",
    };
  }
};

export const getAll_Testimonial = async (creds) => {
  //api.obenev.com/admin/categories
  //api.obenev.com/admin/categories
  // https://api.obenev.com/testimonial

  try {
    const { data } = await axiosInstance.get(`/testimonial`, creds);
    return data;
  } catch (e) {
    return {
      error: "Something went wrong",
    };
  }
};

export const getSingle_Testimonial = async (creds) => {
  //api.obenev.com/admin/categories
  //api.obenev.com/admin/categories
  // https://api.obenev.com/testimonial

  try {
    const { data } = await axiosInstance.get(`/testimonial/${creds}`, creds);
    return data;
  } catch (e) {
    return {
      error: "Something went wrong",
    };
  }
};

export const uploadBanner = async (formData) => {
  try {
    const { data } = await axiosInstance.post("/upload-banner", formData);
    return data;
  } catch (error) {
    console.error("Upload error:", error.response || error);
    return {
      error: true,
      message: error.response?.data?.message || "Something went wrong",
    };
  }
};

// export const postDynamicPage = async (payload) => {
//   const token = localStorage.getItem("obenev-token");
//   try {
//     const { data } = await axiosInstance.post(`/dynamic-page`, payload, {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     });
//     return data;
//   } catch (error) {
//     return {
//       error: true,
//       message: error.response?.data?.message || "Something went wrong",
//     };
//   }
// };

export const postDynamicPage = async (payload) => {
  try {
    const { data } = await axiosInstance.post(`/dynamic-page`, payload);
    return data;
  } catch (error) {
    // 🔥 THROW backend response
    throw error.response?.data || error;
  }
};

// GET dynamic page by ID
export const getDynamicPageById = async (id) => {
  try {
    const { data } = await axiosInstance.get(`/dynamic-page/${id}`);
    return data;
  } catch (error) {
    // You can customize this based on your API response
    if (error.response) {
      // Server responded with a status code out of 2xx
      return {
        error: true,
        message: error.response.data.message || "Failed to fetch page",
      };
    } else if (error.request) {
      // Request was made but no response
      return { error: true, message: "No response from server" };
    } else {
      // Something else happened
      return { error: true, message: error.message || "Something went wrong" };
    }
  }
};

// UPDATE dynamic page

export const dynamicPage_details = async () => {
  try {
    const { data } = await axiosInstance.get(`/dynamic-page`);
    return data?.data || [];
  } catch (e) {
    return {
      error: "Something went wrong",
    };
  }
};

export const deleteDynamic_Page = async (id) => {
  try {
    const { data } = await axiosInstance.delete(`/dynamic-page/${id}`);
    return data;
  } catch (e) {
    return { error: "Something went wrong" };
  }
};

// export const updateDynamic_page = async (id, payload) => {
//   const token = localStorage.getItem("obenev-token");
//   try {
//     const { data } = await axiosInstance.put(`/dynamic-page/${id}`, payload, {
//       headers: { Authorization: `Bearer ${token}` },
//     });
//     return data;
//   } catch (error) {
//     return {
//       error: true,
//       message: error.response?.data?.message || "Something went wrong",
//     };
//   }
// };

export const updateDynamic_page = async (id, payload) => {
  try {
    const { data } = await axiosInstance.put(`/dynamic-page/${id}`, payload);
    return data;
  } catch (error) {
    // 🔥 THROW backend response
    throw error.response?.data || error;
  }
};

export const postTicker = async (payload) => {
  try {
    const { data } = await axiosInstance.post(`/ticker`, payload);
    return data;
  } catch (error) {
    // 🔥 THROW backend response
    throw error.response?.data || error;
  }
};

export const GetTicker = async (payload) => {
  try {
    const { data } = await axiosInstance.get(`/ticker`, payload);
    return data;
  } catch (error) {
    // 🔥 THROW backend response
    throw error.response?.data || error;
  }
};

export const UpdateTicker = async (id, payload) => {
  try {
    const { data } = await axiosInstance.put(`/ticker/${id}`, payload);
    return data;
  } catch (e) {
    return {
      error: "Something went wrong",
    };
  }
};

export const postOffers = async (payload) => {
  try {
    const { data } = await axiosInstance.post(`/offer`, payload);
    return data;
  } catch (error) {
    // 🔥 THROW backend response
    throw error.response?.data || error;
  }
};

export const getOffers = async () => {
  try {
    const { data } = await axiosInstance.get(`/offer`);
    return data?.data || [];
  } catch (e) {
    return {
      error: "Something went wrong",
    };
  }
};

export const UpdateOffer = async (id, payload) => {
  try {
    const { data } = await axiosInstance.put(`/offer/${id}`, payload);
    return data;
  } catch (e) {
    return {
      error: "Something went wrong",
    };
  }
};

export const DeleteOffer = async (id) => {
  try {
    const { data } = await axiosInstance.delete(`admin/offer/${id}`);
    return data;
  } catch (e) {
    return { error: "Something went wrong" };
  }
};

export const updateOrderStatus = async (payload) => {
  try {
    const { data } = await axiosInstance.patch(
      "/customer/update-order-status",
      payload,
    );
    return data;
  } catch (e) {
    return { error: "Something went wrong" };
  }
};
export const fetchVehicleList = async () => {
  try {
    const { data } = await axiosInstance.get("/customer/get-vehicles-list");
    return data;
  } catch (e) {
    return { error: "Something went wrong" };
  }
};
export const saveVehiclePricing = async (pricingData) => {
  try {
    const response = await axiosInstance.patch(
      "/customer/update-vehicle-pricing",
      pricingData,
    );
    return response.data;
  } catch (e) {
    return { error: "Something went wrong" };
  }
};

export const getEvoBookings = async (params = {}) => {
  try {
    // ✅ Use the correct localStorage key
    const token = localStorage.getItem("obenev-token");

    const {
      page = 1,
      pageSize = 10,
      startDate = null,
      endDate = null,
      sortBy = null,
      sortOrder = null,
      search = null,
      status = null,
      bookingType = null,
    } = params;

    // Build query params safely — skip empty/null values
    const queryParams = new URLSearchParams();

    queryParams.append("page", String(page));
    queryParams.append("pageSize", String(pageSize));

    if (startDate) queryParams.append("startDate", startDate);
    if (endDate) queryParams.append("endDate", endDate);
    if (sortBy) queryParams.append("sortBy", sortBy);
    if (sortOrder) queryParams.append("sortOrder", sortOrder);
    if (search && search.trim()) queryParams.append("search", search.trim());
    if (status && status.trim()) queryParams.append("status", status.trim());
    if (bookingType && bookingType.trim())
      queryParams.append("bookingType", bookingType.trim());

    const { data } = await axiosInstance.get(
      `/customer/get-all-evo-bookings?${queryParams}`,
      {
        headers: {
          Accept: "application/json, text/plain, */*",
          "Accept-Language": "en-US,en;q=0.9,hi;q=0.8",
          Authorization: token ? `Bearer ${token}` : "",
        },
      },
    );

    return data;
  } catch (e) {
    console.error("Error in getEvoBookings:", e);
    return {
      error: true,
      message: "Something went wrong",
      details: e.message || "Unknown error",
      bookings: {
        data: [],
        totalCount: 0,
        totalPages: 0,
        currentPage: 1,
        hasPrev: false,
        hasNext: false,
      },
    };
  }
};

// Updated service functions with consistent response structure
export const getCustomersBookingNotAttempted = async (params = {}) => {
  try {
    const token = localStorage.getItem("obenev-token");

    const {
      page = 1,
      pageSize = 10,
      startDate = null,
      endDate = null,
      sortBy = null,
      sortOrder = null,
      search = null,
      status = null,
      bookingType = null,
    } = params;

    const queryParams = new URLSearchParams();

    queryParams.append("page", String(page));
    queryParams.append("pageSize", String(pageSize));

    if (startDate) queryParams.append("startDate", startDate);
    if (endDate) queryParams.append("endDate", endDate);
    if (sortBy) queryParams.append("sortBy", sortBy);
    if (sortOrder) queryParams.append("sortOrder", sortOrder);
    if (search && search.trim()) queryParams.append("search", search.trim());
    if (status && status.trim()) queryParams.append("status", status.trim());
    if (bookingType && bookingType.trim())
      queryParams.append("bookingType", bookingType.trim());

    const response = await axiosInstance.get(
      `/customer/customers-booking-not-attempted?${queryParams}`,
      {
        headers: {
          Accept: "application/json, text/plain, */*",
          "Accept-Language": "en-US,en;q=0.9,hi;q=0.8",
          Authorization: token ? `Bearer ${token}` : "",
        },
      },
    );

    // Transform response to match EVO bookings structure
    const responseData = response.data;
    if (responseData && responseData.data) {
      return {
        user: {
          data: responseData.data.data || [],
          totalCount: responseData.data.totalCount || 0,
          totalPages: responseData.data.totalPages || 1,
          currentPage: responseData.data.currentPage || 1,
          hasPrev: responseData.data.hasPrev || false,
          hasNext: responseData.data.hasNext || false,
        },
        error: responseData.error || false,
        message: responseData.message || "",
      };
    }

    return responseData;
  } catch (e) {
    console.error("Error in getCustomersBookingNotAttempted:", e);
    return {
      error: true,
      message: "Something went wrong",
      details: e.message || "Unknown error",
      user: {
        data: [],
        totalCount: 0,
        totalPages: 0,
        currentPage: 1,
        hasPrev: false,
        hasNext: false,
      },
    };
  }
};

export const getCustomerFailedBooking = async (params = {}) => {
  try {
    const token = localStorage.getItem("obenev-token");

    const {
      page = 1,
      pageSize = 10,
      startDate = null,
      endDate = null,
      sortBy = null,
      sortOrder = null,
      search = null,
      status = null,
      bookingType = null,
    } = params;

    const queryParams = new URLSearchParams();

    queryParams.append("page", String(page));
    queryParams.append("pageSize", String(pageSize));

    if (startDate) queryParams.append("startDate", startDate);
    if (endDate) queryParams.append("endDate", endDate);
    if (sortBy) queryParams.append("sortBy", sortBy);
    if (sortOrder) queryParams.append("sortOrder", sortOrder);
    if (search && search.trim()) queryParams.append("search", search.trim());
    if (status && status.trim()) queryParams.append("status", status.trim());
    if (bookingType && bookingType.trim())
      queryParams.append("bookingType", bookingType.trim());

    const response = await axiosInstance.get(
      `/customer/customer-failed-booking?${queryParams}`,
      {
        headers: {
          Accept: "application/json, text/plain, */*",
          "Accept-Language": "en-US,en;q=0.9,hi;q=0.8",
          Authorization: token ? `Bearer ${token}` : "",
        },
      },
    );

    // Transform response to match EVO bookings structure
    const responseData = response.data;
    if (responseData && responseData.data) {
      return {
        user: {
          data: responseData.data.data || [],
          totalCount: responseData.data.totalCount || 0,
          totalPages: responseData.data.totalPages || 1,
          currentPage: responseData.data.currentPage || 1,
          hasPrev: responseData.data.hasPrev || false,
          hasNext: responseData.data.hasNext || false,
        },
        error: responseData.error || false,
        message: responseData.message || "",
      };
    }

    return responseData;
  } catch (e) {
    console.error("Error in getCustomerFailedBooking:", e);
    return {
      error: true,
      message: "Something went wrong",
      details: e.message || "Unknown error",
      user: {
        data: [],
        totalCount: 0,
        totalPages: 0,
        currentPage: 1,
        hasPrev: false,
        hasNext: false,
      },
    };
  }
};

export const getCustomerFailedPurchase = async (params = {}) => {
  try {
    const token = localStorage.getItem("obenev-token");

    const {
      page = 1,
      pageSize = 10,
      startDate = null,
      endDate = null,
      sortBy = null,
      sortOrder = null,
      search = null,
      status = null,
      bookingType = null,
    } = params;

    const queryParams = new URLSearchParams();

    queryParams.append("page", String(page));
    queryParams.append("pageSize", String(pageSize));

    if (startDate) queryParams.append("startDate", startDate);
    if (endDate) queryParams.append("endDate", endDate);
    if (sortBy) queryParams.append("sortBy", sortBy);
    if (sortOrder) queryParams.append("sortOrder", sortOrder);
    if (search && search.trim()) queryParams.append("search", search.trim());
    if (status && status.trim()) queryParams.append("status", status.trim());
    if (bookingType && bookingType.trim())
      queryParams.append("bookingType", bookingType.trim());

    const response = await axiosInstance.get(
      `/customer/customer-failed-purchase?${queryParams}`,
      {
        headers: {
          Accept: "application/json, text/plain, */*",
          "Accept-Language": "en-US,en;q=0.9,hi;q=0.8",
          Authorization: token ? `Bearer ${token}` : "",
        },
      },
    );

    // Transform response to match EVO bookings structure
    const responseData = response.data;
    if (responseData && responseData.data) {
      return {
        user: {
          data: responseData.data.data || [],
          totalCount: responseData.data.totalCount || 0,
          totalAmount: 0, // These APIs don't have amount, so set to 0
          totalPages: responseData.data.totalPages || 1,
          currentPage: responseData.data.currentPage || 1,
          hasPrev: responseData.data.hasPrev || false,
          hasNext: responseData.data.hasNext || false,
        },
        error: responseData.error || false,
        message: responseData.message || "",
      };
    }

    return responseData;
  } catch (e) {
    console.error("Error in getCustomerFailedPurchase:", e);
    return {
      error: true,
      message: "Something went wrong",
      details: e.message || "Unknown error",
      user: {
        data: [],
        totalCount: 0,
        totalAmount: 0,
        totalPages: 0,
        currentPage: 1,
        hasPrev: false,
        hasNext: false,
      },
    };
  }
};

export const getAdvanceEvoPayments = async (params = {}) => {
  try {
    // ✅ Use the correct localStorage key
    const token = localStorage.getItem("obenev-token");

    const {
      page = 1,
      pageSize = 10,
      startDate = null,
      endDate = null,
      sortBy = null,
      sortOrder = null,
      search = null,
      status = null,
    } = params;

    // Build query params safely — skip empty/null values
    const queryParams = new URLSearchParams();

    queryParams.append("page", String(page));
    queryParams.append("pageSize", String(pageSize));

    if (startDate) queryParams.append("startDate", startDate);
    if (endDate) queryParams.append("endDate", endDate);
    if (sortBy) queryParams.append("sortBy", sortBy);
    if (sortOrder) queryParams.append("sortOrder", sortOrder);
    if (search && search.trim()) queryParams.append("search", search.trim());
    if (status && status.trim()) queryParams.append("status", status.trim());

    const { data } = await axiosInstance.get(
      `/customer/get-all-advance-evo-payments?${queryParams}`,
      {
        headers: {
          Accept: "application/json, text/plain, */*",
          "Accept-Language": "en-US,en;q=0.9,hi;q=0.8",
          Authorization: token ? `Bearer ${token}` : "",
        },
      },
    );

    return data;
  } catch (e) {
    console.error("Error in getAdvanceEvoPayments:", e);
    return {
      error: true,
      message: "Something went wrong",
      details: e.message || "Unknown error",
      payments: {
        data: [],
        totalCount: 0,
        totalPages: 0,
        currentPage: 1,
        hasPrev: false,
        hasNext: false,
      },
    };
  }
};
export const uploadSitemap = async (file, category = "Main") => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    if (category) {
      formData.append("category", category);
    }

    const { data } = await axiosInstance.post(
      "/site-mapping/upload",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return data;
  } catch (error) {
    console.error("Error uploading sitemap:", error);
    return {
      error: error.response?.data?.message || "Failed to upload sitemap",
      status: error.response?.status,
    };
  }
};

export const getAllSiteMappings = async () => {
  try {
    const { data } = await axiosInstance.get("/site-mapping");
    return data;
  } catch (error) {
    console.error("Error fetching site mappings:", error);
    return {
      error: error.response?.data?.message || "Failed to fetch site mappings",
      status: error.response?.status,
    };
  }
};

export const getSiteMappingById = async (id) => {
  try {
    const { data } = await axiosInstance.get(`/site-mapping/${id}`);
    return data;
  } catch (error) {
    console.error(`Error fetching site mapping with id ${id}:`, error);
    return {
      error: error.response?.data?.message || "Failed to fetch site mapping",
      status: error.response?.status,
    };
  }
};


export const getParentSiteMappingById = async (id) => {
  try {
    const { data } = await axiosInstance.get(`/site-mapping/singleparent?sitemap=${id}`);
    return data;
  } catch (error) {
    console.error(`Error fetching site mapping with id ${id}:`, error);
    return {
      error: error.response?.data?.message || "Failed to fetch site mapping",
      status: error.response?.status,
    };
  }
};

export const updateSiteMapping = async (id, updateData) => {
  try {
    const { data } = await axiosInstance.put(
      `/site-mapping/${id}`,
      updateData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    return data;
  } catch (error) {
    console.error(`Error updating site mapping with id ${id}:`, error);
    return {
      error: error.response?.data?.message || "Failed to update site mapping",
      status: error.response?.status,
    };
  }
};

export const updatePrentSiteMapping = async (id, updateData) => {
  try {
    const { data } = await axiosInstance.put(
      `/site-mapping?sitemap=${id}`,
      updateData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    return data;
  } catch (error) {
    console.error(`Error updating site mapping with id ${id}:`, error);
    return {
      error: error.response?.data?.message || "Failed to update site mapping",
      status: error.response?.status,
    };
  }
};

export const deleteChildSiteMapping = async (id) => {
  try {
    const { data } = await axiosInstance.delete(`/site-mapping/${id}`);
    return data;
  } catch (error) {
    console.error(`Error deleting site mapping with id ${id}:`, error);
    return {
      error: error.response?.data?.message || "Failed to delete site mapping",
      status: error.response?.status,
    };
  }
};
export const deleteSiteMapping = async (id) => {
  try {
    const { data } = await axiosInstance.delete(`/site-mapping?sitemap=${id}`);
    return data;
  } catch (error) {
    console.error(`Error deleting site mapping with id ${id}:`, error);
    return {
      error: error.response?.data?.message || "Failed to delete site mapping",
      status: error.response?.status,
    };
  }
};

export const getSitemapContent = async (id) => {
  try {
    const mappingData = await getSiteMappingById(id);

    if (mappingData.error) {
      return mappingData;
    }

    const xmlContent = constructXMLFromMapping(mappingData);
    return { ...mappingData, xmlContent };
  } catch (error) {
    console.error("Error fetching sitemap content:", error);
    return { error: "Failed to fetch sitemap content" };
  }
};

export const getParentSitemapContent = async (id) => {
  try {
    const mappingData = await getParentSiteMappingById(id);

    if (mappingData.error) {
      return mappingData;
    }

    const xmlContent = constructXMLFromMapping(mappingData);
    return { ...mappingData, xmlContent };
  } catch (error) {
    console.error("Error fetching sitemap content:", error);
    return { error: "Failed to fetch sitemap content" };
  }
};

const constructXMLFromMapping = (mappingData) => {
  if (!mappingData.loc) return "";

  let xml = '<?xml version="1.0" encoding="UTF-8"?>\n';
  xml += '<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">\n';
  xml += "  <url>\n";
  xml += `    <loc>${mappingData.loc}</loc>\n`;
  if (mappingData.lastmod)
    xml += `    <lastmod>${mappingData.lastmod}</lastmod>\n`;
  if (mappingData.changefreq)
    xml += `    <changefreq>${mappingData.changefreq}</changefreq>\n`;
  if (mappingData.priority)
    xml += `    <priority>${mappingData.priority}</priority>\n`;
  xml += "  </url>\n";
  xml += "</urlset>";
  return xml;
};

// ist of child sitemaps api
export const getChildSiteMappings = async (sitemapUrl, { page = 1, limit = 20 } = {}) => {
  try {
    const response = await axiosInstance.get("/site-mapping", {
      params: { sitemap: sitemapUrl, page, limit },
    });
    return response.data;
  } catch (err) {
    return { error: err.response?.data?.message || "Failed to load URLs" };
  }
};

export const getVasOrders = async (params = {}) => {
  try {
    const token = localStorage.getItem("obenev-token");

    const {
      page = 1,
      pageSize = 10,
      startDate = null,
      endDate = null,
      sortBy = null,
      sortOrder = null,
      search = null,
      status = null,
    } = params;

    const queryParams = new URLSearchParams();

    queryParams.append("page", String(page));
    queryParams.append("pageSize", String(pageSize));

    if (startDate) queryParams.append("startDate", startDate);
    if (endDate) queryParams.append("endDate", endDate);
    if (sortBy) queryParams.append("sortBy", sortBy);
    if (sortOrder) queryParams.append("sortOrder", sortOrder);
    if (search && search.trim()) queryParams.append("search", search.trim());
    if (status && status.trim()) queryParams.append("status", status.trim());

    const { data } = await axiosInstance.get(
      `/customer/get-all-vas-orders?${queryParams}`,
      {
        headers: {
          Accept: "application/json, text/plain, */*",
          "Accept-Language": "en-US,en;q=0.9,hi;q=0.8",
          Authorization: token ? `Bearer ${token}` : "",
        },
      },
    );

    return data;
  } catch (e) {
    console.error("Error in getVasOrders:", e);
    return {
      error: true,
      message: "Something went wrong",
      details: e.message || "Unknown error",
      data: {
        data: [],
        totalCount: 0,
        totalPages: 0,
        currentPage: 1,
        hasPrev: false,
        hasNext: false,
      },
    };
  }
};

export const getAllPreEvoBookings = async (params = {}) => {
  try {
    const token = localStorage.getItem("obenev-token");

    const {
      page = 1,
      pageSize = 10,
      startDate = null,
      endDate = null,
      sortBy = null,
      sortOrder = null,
      search = null,
      status = null,
      bookingType = null,
    } = params;

    const queryParams = new URLSearchParams();

    queryParams.append("page", String(page));
    queryParams.append("pageSize", String(pageSize));

    if (startDate) queryParams.append("startDate", startDate);
    if (endDate) queryParams.append("endDate", endDate);
    if (sortBy) queryParams.append("sortBy", sortBy);
    if (sortOrder) queryParams.append("sortOrder", sortOrder);
    if (search && search.trim()) queryParams.append("search", search.trim());
    if (status && status.trim()) queryParams.append("status", status.trim());
    if (bookingType && bookingType.trim())
      queryParams.append("bookingType", bookingType.trim());

    const { data } = await axiosInstance.get(
      `/customer/get-all-pre-evo-bookings?${queryParams}`,
      {
        headers: {
          Accept: "application/json, text/plain, */*",
          "Accept-Language": "en-US,en;q=0.9,hi;q=0.8",
          Authorization: token ? `Bearer ${token}` : "",
        },
      },
    );

    return data;
  } catch (e) {
    console.error("Error in getAllPreEvoBookings:", e);
    return {
      error: true,
      message: "Something went wrong",
      details: e.message || "Unknown error",
      bookings: {
        data: [],
        totalCount: 0,
        totalPages: 0,
        currentPage: 1,
        hasPrev: false,
        hasNext: false,
      },
    };
  }
};
